/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const GetClusterUpgrade = {
  id: 'cluster-upgrade.get',
  tag: 'Cluster',
  summary: 'Get a cluster upgrade PostgreSQL version status',
  description: 'Get a cluster upgrade PostgreSQL version status within an organization project',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/upgrade`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            status: z.enum(['accepted', 'success', 'failure']),
            isScheduled: z.boolean(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
